import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as authActions from '../Services/Authentication/action'
import { isValidToken } from '../Lib/constants'
import { Spinner } from 'react-bootstrap'
import '../Assets/Css/PrivateRoute.scss'


const PrivateRoute = (props) => {

    const [loggedIn, setLoggedIn] = useState(false)
    const navigate = useNavigate()

    const islogin = () => {
        console.log("check ran")
        setLoggedIn(false)
        const localUser = JSON.parse(localStorage.getItem('user'))
        if (localUser) {
            const response = isValidToken(localUser.exp)
            console.log(response)
            if (response) {
                setLoggedIn(true)
                return true
            } else {
                props.refreshToken(localUser.refreshToken).then((response) => {
                    if (response.status === 200) {
                        localUser.accessToken = response.data.accessToken
                        localUser.exp = response.data.exp
                        console.log("Token refreshed successfully!")
                        localStorage.setItem('user', JSON.stringify(localUser))
                        setLoggedIn(true)
                        return true
                    } else {
                        localStorage.removeItem('user')
                        setLoggedIn(false)
                        navigate('/login')
                        return false
                    }
                }).catch((e) => { console.log("error", e); setLoggedIn(false); return navigate('/login') })
            }
        }else{
            navigate('/login')
        }

    }

    useEffect(() => {
        islogin()
    }, [props.element])

    if (loggedIn) {
        return (
            props.element
        )
    } else {
        return (
            <div className='home-main' >
                <Spinner animation='grow' />
            </div>
        )
    }
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = {
    refreshToken: authActions.refreshToken
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)